import type { IAccount } from "../Accounting"
import type { ICab } from "../Cabs"
import { ICabSchedule } from "../CabScheduling"
import type { TDriver } from "../Drivers"
import { ITrip } from "../Trips"
import type { IContact } from "../Contacts"
import { IPaymentPreference } from "../SupplierPaymentPreferences"
import { useXHR } from "@sembark-travel/xhr"
import useSWR from "swr"
import { SupplierXHR } from "./Item"

export type TSupplyType = "cabs" | "travel_activities" | "hotels"

export enum ServiceType {
	TransportBookingServices = "transport_booking_services",
	HotelBookingServices = "hotel_booking_services",
	ActivityBookingServices = "activity_booking_services",
}

export type TSupplierContact = IContact

export interface ISupplier {
	id: number
	name: string
	contact?: TSupplierContact
	contacts?: TSupplierContact[]
	accounting_accounts?: Array<IAccount>
	drivers?: Array<TDriver>
	solo_driver: boolean
	cabs?: Array<ICab>
	supplies_cabs: boolean
	supplies_travel_activities: boolean
	supplies_hotels: boolean
	disabled_at?: string
	disabled_by?: string
	booking_exists?: {
		cab_bookings: boolean
		travel_activity_bookings: boolean
		hotel_bookings: boolean
	}
	activity_supplier_payment_preference: IPaymentPreference | null
	hotel_supplier_payment_preference: IPaymentPreference | null
	transport_supplier_payment_preference: IPaymentPreference | null
}

export interface ITSPTripWiseCabsSchedule extends ITrip {
	schedules: Array<ICabSchedule>
}

export function useSupplier({ supplierId }: { supplierId: number | string }) {
	const xhr = useXHR()
	const {
		data: supplier,
		mutate,
		isLoading,
		isValidating,
		error,
	} = useSWR(`/transport-service-providers/${supplierId}`, () =>
		SupplierXHR(xhr).getSupplierById(supplierId.toString())
	)
	return {
		supplier,
		error,
		revalidate: mutate,
		isLoading,
		isValidating,
	}
}
